<template>
  <p class="small" v-safe-html="text" />
</template>

<script setup>
defineProps({
  text: {
    type: String,
    required: true,
  },
});
</script>
